@if (!this.canAccessInboxAiSupport()) {
  <h2 mat-dialog-title>{{ 'CONTACT_SALESPERSON.CONTACT' | translate }} Vendasta</h2>
}

<mat-dialog-content>
  <div class="dialog-content">
    @if (isLoading()) {
      <div class="loading-container">
        <glxy-loading-spinner></glxy-loading-spinner>
      </div>
    } @else {
      @if (this.canAccessInboxAiSupport()) {
        <div class="ai-support-container">
          <span class="card-title">{{ 'ASSIGNED_SALESPERSON_CARD.TITLE' | translate }}</span>
          <inbox-ai-support-banner (chatWithAiButtonClicked)="chatWithAiButtonClicked()"> </inbox-ai-support-banner>
        </div>
      }
      <div class="salesperson-container row">
        <img src="{{ imgUrl }}" />
        <div class="contact-container">
          <div class="person-name">{{ name }}</div>
          <div class="person-title">{{ title }}</div>
          <div class="person-away-message">{{ awayMessage$ | async }}</div>

          <div class="contact-info">
            @if (tel) {
              <div class="contact-info-item">
                <mat-icon class="contact-info-item-icon">phone</mat-icon>
                <span class="contact-info-item-value">{{ tel | formatPhoneNumber: countryCode }}</span>
              </div>
            }
            @if (email) {
              <div class="contact-info-item">
                <mat-icon class="contact-info-item-icon">email</mat-icon>
                <span class="contact-info-item-value">{{ email }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      @if (!this.canAccessInbox()) {
        <mat-form-field class="contact-text-area">
          <textarea
            class="sales-message-text"
            matInput
            cdkFocusInitial
            [(ngModel)]="message"
            (ngModelChange)="enableSend()"
            placeholder="{{ 'COMMON.ACTION_LABELS.COMPOSE_MESSAGE' | translate }}"
            matTextareaAutosize
            matAutosizeMinRows="2"
            matAutosizeMaxRows="10"
            maxlength="500"
          ></textarea>
          <mat-hint align="end">{{ message.length }} / 500</mat-hint>
        </mat-form-field>
      } @else {
        @if (!this.canAccessInboxAiSupport()) {
          <mat-divider class="contact-info-divider"></mat-divider>
        }
        <div class="contact-actions">
          @if (tel) {
            <a mat-stroked-button href="tel:{{ tel }}" class="contact-action">
              {{ 'COMMON.ACTION_LABELS.CALL' | translate }}
            </a>
          }
          @if (bookMeetingUrl$ | async; as bookMeetingUrl) {
            <a mat-stroked-button href="{{ bookMeetingUrl }}" target="_blank" class="contact-action">
              {{ 'COMMON.ACTION_LABELS.BOOK_A_MEETING' | translate }}
            </a>
          }
          <div class="contact-action">
            <inbox-button-send-message
              class="full-width-button"
              [type]="'alternative'"
              [buttonText]="'COMMON.ACTION_LABELS.CHAT' | translate"
              [showIcon]="false"
              [config]="{
                currentParticipant: currentIAMParticipant$ | async,
                subjectParticipants: salesContactSubjectParticipants$ | async,
                channel: salesConversationChannel,
              }"
              (closeModal)="close()"
            ></inbox-button-send-message>
          </div>
        </div>
      }
    }
  </div>
</mat-dialog-content>

@if (!this.canAccessInbox() && !isLoading()) {
  <mat-dialog-actions>
    <button mat-stroked-button (click)="close()">
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    @if (!buttonEnabled) {
      <button mat-flat-button color="primary">
        {{ 'COMMON.ACTION_LABELS.SEND' | translate }}
      </button>
    } @else if (sending) {
      <button mat-stroked-button>
        <span>
          <mat-progress-spinner mode="indeterminate" diameter="24" color="accent"></mat-progress-spinner>
        </span>
      </button>
    } @else {
      <button mat-flat-button color="primary" (click)="send()">
        {{ 'COMMON.ACTION_LABELS.SEND' | translate }}
      </button>
    }
  </mat-dialog-actions>
}
